import { render, staticRenderFns } from "./Internal-Payment-Credit.vue?vue&type=template&id=b4e3c808"
import script from "./Internal-Payment-Credit.vue?vue&type=script&lang=js"
export * from "./Internal-Payment-Credit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports